import React, { lazy, Suspense } from 'react';
import cn from 'classnames';

import LazyImage from 'components/UI/LazyImage';
import Icon from 'components/UI/Icon';
import Link from 'components/UI/Link';
import VideoCaption from './VideoCaption';
import PersonalData from './PersonalData';
import { useTrans } from 'utils/localisation';
import { useStateModal } from 'utils/hooks';

import * as styles from './ReviewInfo.module.scss';

const PlayerModal = lazy(() => import('components/Modals/PlayerModal'));

export default function ReviewInfo({
  company,
  company_link,
  company_logo,
  description,
  linkedin,
  name,
  photo,
  position,
  summary,
  theme,
  video,
  case_url,
}) {
  const t = useTrans(['testimonials', 'common']);
  const { modalState, showModal, hideModal } = useStateModal();

  return (
    <article className={cn(styles.card, theme && styles[theme])}>
      <div className={styles.wrapper}>
        <section className={cn(styles.section, video && styles.withVideo)}>
          {video ? (
            <div className={styles.posterWrapper} role="button" onClick={showModal}>
              <LazyImage src={video.poster} className={styles.poster} alt="poster" />
              <VideoCaption
                title={name}
                linkedin={linkedin}
                position={position}
                company={company}
                companyLink={company_link}
              />
              <Icon name="video-play-circle" className={styles.buttonPlay} />
            </div>
          ) : (
            <>
              <p className={styles.review}>{description}</p>
              <PersonalData
                photo={photo}
                name={name}
                linkedin={linkedin}
                position={position}
                company={company}
                companyLink={company_link}
              />
            </>
          )}
        </section>
        <section className={cn(styles.section, video && styles.dynamicMobileHeight)}>
          {company_logo && (
            <div className={styles.logoWrapper}>
              <LazyImage className={styles.logo} src={company_logo} alt="Company logo" />
            </div>
          )}
          <p className={styles.text}>{summary}</p>
          {case_url && (
            <Link className={styles.link} href={case_url}>
              {t('viewCaseStudy')}
            </Link>
          )}
        </section>
      </div>
      {video && (
        <Suspense fallback={null}>
          <PlayerModal
            isOpen={modalState.isOpen}
            closeModalCallback={hideModal}
            data={{
              videoSrc: video.url,
              videoPoster: video.poster,
              videoCaption: { title: name, position, company },
            }}
          />
        </Suspense>
      )}
    </article>
  );
}
